/** experiment ids go here */
export const EXP_038_GOOD_BETTER_BEST = 'exp_038_good_better_best';
